import './App.css';
import {BrowserRouter as Router, Switch, Route, useHistory} from 'react-router-dom';
import   Home   from './pages/Home';
import Footer from './Components/Footer';
import SearchNav from './Components/SearchNav';
import NavBar from './Components/NavBar';
import { PageLayout } from './Components/PageLayout';
import { MsalProvider } from "@azure/msal-react";
import { CustomNavigationClient } from "./utils/NavigationClient";

function App({ pca }) {
  // The next 3 lines are optional. This is how you configure MSAL to take advantage of the router's navigate functions when MSAL redirects between pages in your app
  const history = useHistory();
  const navigationClient = new CustomNavigationClient(history);
  
  pca.setNavigationClient(navigationClient);
  return (    
    <MsalProvider instance={pca}>      
      <PageLayout>
        <div container justifyContent="center">
       <Pages />       
        </div>
      </PageLayout>
    </MsalProvider>
  );
}

function Pages() {
 return (
      <>
      <Router>
      <SearchNav/>
      <NavBar/>
         <Switch>
         <Route exact path='/home'>
          <Home />
          </Route>
          <Route exact path='/'>
          <Home />
          </Route>
        
       </Switch>        
      </Router>
      <Footer/>      
      </>
    );
  
}
export default App;
